import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAppStore = defineStore('sb1162', () => ({
    theme: ref('light'),
    form: ref({}),
    statusForm: ref({
        id: undefined,
        uuid: undefined
    }),
    validCityStatePairs: ref({}),
    location: ref({
        timestamp: undefined
    }),
}),
    {

        persist: {
            debug: false,
        }
    }
)